import React, { FC } from 'react';
import { useDispatch } from 'react-redux';

import LeftPanelHeader from 'components/LeftPanel/LeftPanelHeader';
import LeftPanelMenu from 'components/LeftPanel/LeftPanelMenu';
import { userSettingsByKeySelector } from 'store/selectors/userSelectors';
import { setLeftPanelAction } from 'store/actions/userActions';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { LeftPanelStyled } from 'components/LeftPanel/styled';
import { BlocksIcn, MenuToggleIcn } from 'utils/icons';

const key = 'isCollapsedLeftPanel';

const LeftPanel: FC = () => {
  const dispatch = useDispatch();
  const isCollapsedLeftPanel = useTypedSelector((state) => userSettingsByKeySelector({ key, ...state }));
  const blocksOpacity = isCollapsedLeftPanel ? 'opacity-0' : 'opacity-100';

  const handleCollapse = () => dispatch(setLeftPanelAction({ isCollapsedLeftPanel: !isCollapsedLeftPanel }));

  return (
    <LeftPanelStyled
      collapsible
      width={220}
      collapsedWidth={70}
      trigger={<MenuToggleIcn className="text-black-0 dark:text-black-30 clickable" />}
      collapsed={isCollapsedLeftPanel}
      onCollapse={handleCollapse}
    >
      <LeftPanelHeader />
      <LeftPanelMenu />
      <BlocksIcn className={`absolute w-full top-[400px] duration-300 ${blocksOpacity}`} />
    </LeftPanelStyled>
  );
};

export default LeftPanel;
